import React from "react";
import { useTranslation } from "../langs/useTranslation";
import { getScheduleTemplatesApi } from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";
import ScheduleType from "@/containers/Schedule/CreateTemplate/TaskCreator/ScheduleType";
import ScheduleTaskType from "@/containers/Schedule/CreateTemplate/TaskCreator/TaskType";
import TaskTime from "@/containers/Schedule/CreateTemplate/TaskCreator/TaskTime";
import ScheduleTaskRange from "@/containers/Schedule/CreateTemplate/TaskCreator/TaskRange";
import { utcFormatToLocalDateTimeWithSecond } from "./datetimeHandlers";

export const EnabledScheduleTemplateListDatatable = React.forwardRef(
  (
    { className, style, footer, children, onCheckAll, onLoaded, getDevices },
    ref
  ) => {
    const { t } = useTranslation();

    const columns = [
      {
        name: "schedule_template_id",
        data: "schedule_template_id",
        type: "checkbox"
      },
      {
        name: "schedule_template_name",
        data: "schedule_template_name",
        title: t({ defaultMessage: "排程模板名称" }),
        searchable: true
      },
      {
        data: "task_type",
        title: t({ defaultMessage: "排程任务" }),
        createdCell: (td, data, row) => {
          ReactRender(<ScheduleTaskType data={row} />, td);
        }
      },
      {
        data: "schedule_type",
        title: t({ defaultMessage: "循环模式" }),
        createdCell: (td, data, row) => {
          ReactRender(<ScheduleType data={row} />, td);
        }
      },
      {
        data: "start_datetime",
        title: t({ defaultMessage: "执行时间" }),
        createdCell: (td, data, row) => {
          ReactRender(<TaskTime data={row} />, td);
        }
      },
      {
        data: "end_datetime",
        title: t({ defaultMessage: "执行期间" }),
        createdCell: (td, data, row) => {
          ReactRender(<ScheduleTaskRange data={row} />, td);
        }
      },
      {
        data: "create_user_name",
        title: t({ defaultMessage: "创建人" })
      },
      {
        name: "schedule_template_name",
        data: "schedule_template_created_at",
        title: t({ defaultMessage: "创建时间" }),
        searchable: false,
        render: data => {
          return utcFormatToLocalDateTimeWithSecond(data);
        }
      }
    ];

    const ajax = (data, callback) => {
      return getScheduleTemplatesApi({
        ...data,
        // device_ids: getDevices().map(item => item.id),
        status: 1
      }).then(res => {
        callback({
          data: res.data,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        rowsGroup={[
          "schedule_template_id:name",
          "schedule_template_name:name",
          "create_user_name:name"
        ]}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        footer={footer}
        onCheckAll={onCheckAll}
        onLoaded={onLoaded}
        autoLoad
      >
        {children}
      </DataTable>
    );
  }
);
